import {
  OrderNumberingStrategyDateFormat,
  OrderNumberingStrategyType,
} from "@/redux/services/restaurant/restaurant.type";

export interface OrderNumberPreviewInput {
  type?: OrderNumberingStrategyType | string | null;
  dateFormat?: OrderNumberingStrategyDateFormat | string | null;
  prefix?: string | null;
  padding?: number | string | null;
  startNumber?: number | string | null;
}

const two = (n: number) => n.toString().padStart(2, "0");

function formatDate(dateFormat: string | null | undefined, date: Date): string {
  const Y = date.getFullYear().toString();
  const m = two(date.getMonth() + 1);
  const d = two(date.getDate());
  const Hi = `${two(date.getHours())}${two(date.getMinutes())}`;

  switch (dateFormat) {
    case OrderNumberingStrategyDateFormat.DDMMYYYY:
      return `${d}${m}${Y}`;
    case OrderNumberingStrategyDateFormat.MMDDYYYY:
      return `${m}${d}${Y}`;
    case OrderNumberingStrategyDateFormat.YYYYMMDD:
      return `${Y}${m}${d}`;
    case OrderNumberingStrategyDateFormat.DDMMYYYYHHMM:
      return `${d}${m}${Y}${Hi}`;
    case OrderNumberingStrategyDateFormat.MMDDYYYYHHMM:
      return `${m}${d}${Y}${Hi}`;
    case OrderNumberingStrategyDateFormat.YYYYMMDDHHMM:
      return `${Y}${m}${d}${Hi}`;
    default:
      return "";
  }
}

/**
 * Example order number, built like the API (scanifood_api
 * OrderNumberGenerator::generateOrderNumber()): prefix + left-padded body.
 * - sequential: body = start number;
 * - date_based: body = date + daily sequence on at least 3 digits (the first
 *   order of the day is 001); startNumber is not used (SFRESTO-145).
 */
export function orderNumberPreview(
  { type, dateFormat, prefix, padding, startNumber }: OrderNumberPreviewInput,
  now: Date = new Date()
): string {
  // An empty or zero padding field falls back to 2 (unchanged behaviour).
  const width = Number(padding) || 2;
  const body =
    type === OrderNumberingStrategyType.Date
      ? `${formatDate(dateFormat, now)}001`
      : String(startNumber ?? 1);

  return `${prefix ?? ""}${body.padStart(width, "0")}`;
}
